import {showSuccess} from "@/utils/notifications";

export default {
    created() {
        if (this.$route.query.message) {
            showSuccess(this.$route.query.message);
            this.$router.push({
                path: this.$route.path,
                query: {
                },
            });
        }
    }
}
